import * as React from 'react';
import styled, { useTheme } from 'styled-components';
import { ArrowRightIcon } from '../icons';

const Wrapper = styled.div`
  padding: 50px 40px 50px 40px;
  border-radius: 20px;
  box-shadow: 0 0 0.8px 0 rgba(0, 0, 0, 0.04), 0 1.7px 5px 0 rgba(0, 0, 0, 0.04),
    0 8.3px 16.5px 0 rgba(0, 0, 0, 0.04);
  background-color: ${({ theme, background }) => background || theme.palette.background.whiteBg400};
  flex: 1 1 40%;
  max-width: 40%;
  &:nth-child(2n + 1) {
    margin-top: 100px;
    @media (max-width: 768px) {
      margin-top: 0;
    }
  }
  &:nth-child(2n) {
    margin-bottom: 100px;
    @media (max-width: 768px) {
      margin-bottom: 40px;
    }
  }
  @media (max-width: 768px) {
    flex: 1 1 100%;
    max-width: 100%;
    margin-bottom: 40px;
  }
`;
const WorkTitle = styled.h3`
  font-size: 30px;
  font-weight: 400;
`;
const WorkLogo = styled.div`
  width: 100px;
  img {
    object-fit: cover;
  }
`;
const HeaderCard = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  img {
    width: 100%;
    @media (max-width: 768px) {
      margin-bottom: 14px;
    }
  }
  @media (max-width: 768px) {
    flex-direction: column-reverse;
    justify-content: center;
    text-align: center;
  }
`;
const Date = styled.p`
  margin: 7px 169px 24px 0;
  font-size: 16px;
  font-weight: 400;
  color: ${(props) => props.theme.palette.text.secondary};
  @media (max-width: 768px) {
    margin: 20px auto;
    text-align: center;
  }
`;
const Description = styled.p`
  margin: 24px 5px 40px 0;
  font-size: 1rem;
  color: ${(props) => props.theme.palette.text.primary};
`;
const TagList = styled.div`
  display: flex;
  @media (max-width: 768px) {
    /* flex-wrap: wrap; */
    display: none;
  }
`;
const Tag = styled.p`
  margin-right: 16px;
  padding: 7px 15px 5px;
  border-radius: 13px;
  background-color: rgba(123, 136, 168, 0.2);
  font-size: 14px;
  text-transform: capitalize;
  @media (max-width: 768px) {
    margin-bottom: 15px;
  }
`;
const WorkDetails = styled.div`
  @media (max-width: 768px) {
    margin-bottom: 25px;
  }
`;
const WorkInfoRow = styled.div`
  display: flex;
`;
const WorkInfoLabel = styled.p`
  flex: 1 1 120px;
  max-width: 120px;
  margin-bottom: 10px;
  font-size: 14px;
  color: ${(props) => props.theme.palette.text.secondary};
`;
const WorkInfoDescription = styled.p`
  flex: 1;
  color: ${(props) => props.theme.palette.text.primary};
  font-size: 1rem;
  line-height: 1.75;
`;
const WorkMainImage = styled.div`
  /* width: 80%; */
  margin: auto;
  margin-top: 50px;
  margin-bottom: 30px;
  img {
    width: 100%;
    height: 250px;
    object-fit: cover;
    object-position: center top;
    filter: grayscale(0.2);
  }
  @media (max-width: 768px) {
    display: none;
  }
`;
const WorkLink = styled.a`
  display: flex;
  align-items: center;
  margin: 3.9px 16px 4.8px 0;
  font-size: 16px;
  font-weight: bold;
  color: ${(props) => props.theme.palette.primary.main};
  svg {
    margin-left: 15px;
  }
`;

const WorkInfoCard = ({
  id,
  companyLogo,
  projectName,
  date,
  duration,
  tags,
  description,
  company,
  position,
  thumbnail,
  link,
}) => {
  const theme = useTheme();
  const handleBgCard = (string) => {
    let color;
    switch (string) {
      case 0:
        color = theme.palette.background.whiteBg200;
        break;
      case 1:
        color = theme.palette.background.whiteBg400;
        break;
      case 2:
        color = theme.palette.background.whiteBg300;
        break;
      case 3:
        color = theme.palette.background.whiteBg700;
        break;
      case 4:
        color = theme.palette.background.whiteBg500;
        break;
      case 5:
        color = theme.palette.background.whiteBg600;
        break;
      default:
        color = theme.palette.background.whiteBg600;
        break;
    }
    return color;
  };

  return (
    <Wrapper background={handleBgCard(id)}>
      <HeaderCard>
        <WorkTitle>{projectName}</WorkTitle>
        <WorkLogo>
          <img src={companyLogo} alt="" />
        </WorkLogo>
      </HeaderCard>
      <Date>
        {date} • {duration}
      </Date>
      <TagList>
        {tags.map((tag) => (
          <Tag>{tag}</Tag>
        ))}
      </TagList>
      <Description>{description}</Description>
      <WorkDetails>
        <WorkInfoRow>
          <WorkInfoLabel>Organization</WorkInfoLabel>
          <WorkInfoDescription>{company}</WorkInfoDescription>
        </WorkInfoRow>
        <WorkInfoRow>
          <WorkInfoLabel>Role</WorkInfoLabel>
          <WorkInfoDescription>{position}</WorkInfoDescription>
        </WorkInfoRow>
      </WorkDetails>
      <WorkMainImage>
        <img src={thumbnail} alt="" />
      </WorkMainImage>
      <WorkLink href={link} target="_blank">
        Watch Live <ArrowRightIcon color={theme.palette.primary.main} />
      </WorkLink>
    </Wrapper>
  );
};

export default WorkInfoCard;
